/* eslint-disable @typescript-eslint/no-restricted-imports */
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import type { RouteComponentProps } from "react-router-dom";
import { withRouter } from "react-router-dom";
import type { InjectedFormProps } from "redux-form";
import { change, reduxForm, formValueSelector } from "redux-form";
import StyledForm from "components/editorComponents/Form";
import { FormActions, FormMessagesContainer } from "./StyledComponents";
import {
  ALREADY_HAVE_AN_ACCOUNT,
  SIGNUP_PAGE_LOGIN_LINK_TEXT,
  FORGOT_PASSWORD_PAGE_EMAIL_INPUT_PLACEHOLDER,
  FORGOT_PASSWORD_PAGE_SUBMIT_BUTTON_TEXT,
  FORGOT_PASSWORD_PAGE_TITLE,
  FORM_VALIDATION_EMPTY_EMAIL,
  FORM_VALIDATION_INVALID_EMAIL,
  FORGOT_PASSWORD_PAGE_LOGIN_LINK,
  createMessage,
  LOGIN_PAGE_CAPTCHA_INPUT_PLACEHOLDER,
  LOGIN_PAGE_REFRESH_CAPTCHA_TEXT,
} from "ee/constants/messages";
import { AUTH_LOGIN_URL } from "constants/routes";
import {
  FORGOT_PASSWORD_FORM_NAME,
  LOGIN_FORM_CAPTCHA_FIELD_NAME,
} from "ee/constants/forms";
import FormTextField from "components/utils/ReduxFormTextField";
import { FormGroup } from "design-system-old";
import { Button, Link, Callout } from "design-system";
import { isEmail, isEmptyString } from "utils/formhelpers";
import type { ForgotPasswordFormValues } from "./helpers";
import { forgotPasswordSubmitHandler } from "./helpers";
import Container from "./Container";
import { message, Button as AntdButton, ConfigProvider } from "antd";
import styled, { css } from "styled-components";
import { getAppsmithConfigs } from "ee/configs";
import { LoginForm, StyledEmailIcon, StyledLink } from "./Login";
import UserApi from "ee/api/UserApi";
import { isEmpty } from "lodash";
import { Flex, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import GradientButton from "components/GradientButton";

export const FormBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  a > span {
    font-size: 16px;
  }
`;

const { mailEnabled } = getAppsmithConfigs();

const validate = (values: ForgotPasswordFormValues) => {
  const errors: ForgotPasswordFormValues = {};
  if (!values.email || isEmptyString(values.email)) {
    errors.email = createMessage(FORM_VALIDATION_EMPTY_EMAIL);
  } else if (!isEmail(values.email)) {
    errors.email = createMessage(FORM_VALIDATION_INVALID_EMAIL);
  }
  return errors;
};

type ForgotPasswordProps = InjectedFormProps<
  ForgotPasswordFormValues,
  { emailValue: string; verifyCode: string }
> &
  RouteComponentProps<{ email: string }> & {
    emailValue: string;
    verifyCode: string;
  };

export const ForgotPassword = (props: ForgotPasswordProps) => {
  const { error, handleSubmit, submitFailed, submitSucceeded, submitting } =
    props;
  const dispatch = useDispatch();
  const mailEnabled = window.APPSMITH_FEATURE_CONFIGS.mailEnabled;

  const [captchaBlobUrl, setCaptchaBlob] = useState<any>();

  const fetchCaptcha = async () => {
    const res: any = await UserApi.fetchCaptcha();
    const codeImg = window.URL.createObjectURL(res);
    setCaptchaBlob(codeImg);
  };

  useEffect(() => {
    fetchCaptcha();

    // 50s
    const captchaTimer = setInterval(() => {
      fetchCaptcha();
    }, 50000);

    return () => {
      clearInterval(captchaTimer);
    };
  }, []);

  useEffect(() => {
    if (submitSucceeded) {
      props.reset();
      dispatch(change(FORGOT_PASSWORD_FORM_NAME, "email", ""));
      dispatch(change(FORGOT_PASSWORD_FORM_NAME, "verifyCode", ""));
    }
  }, [props.emailValue, props.verifyCode]);

  useEffect(() => {
    if (!mailEnabled) {
      message.open({
        type: "error",
        duration: 30,
        content: `系统未开通邮件服务，不能正常发送重置邮件`,
        className: "my-msg",
      });
    } else {
      message.open({
        type: "success",
        duration: 10,
        content: `您的邮箱服务已配置，可正常发送邮件`,
        className: "my-msg",
      });
    }
    return () => {
      message.destroy();
    };
  }, []);

  const disabled =
    !(mailEnabled && isEmail(props.emailValue)) && isEmpty(props.verifyCode);

  return (
    <Container
      subtitle={
        <Link
          className="text-sm justify-center"
          startIcon="arrow-left-line"
          target="_self"
          to={AUTH_LOGIN_URL}
        >
          {createMessage(FORGOT_PASSWORD_PAGE_LOGIN_LINK)}
        </Link>
      }
      title={createMessage(FORGOT_PASSWORD_PAGE_TITLE)}
    >
      {/* <FormMessagesContainer>
        {submitFailed && error && <Callout kind="warning">{error}</Callout>}
      </FormMessagesContainer> */}
      <StyledForm onSubmit={handleSubmit(forgotPasswordSubmitHandler)}>
        <FormGroup
          intent={error ? "danger" : "none"}
          style={{ position: "relative" }}
        >
          <LoginForm>
            <FormTextField
              disabled={submitting}
              name="email"
              placeholder={createMessage(
                FORGOT_PASSWORD_PAGE_EMAIL_INPUT_PLACEHOLDER,
              )}
              className="pp-height"
            />
          </LoginForm>
          <StyledEmailIcon height={15} width={15} />
        </FormGroup>
        <FormGroup intent={"none"}>
          <div className="flex flex-col [@media(min-width:450px)]:flex-row justify-between">
            <div className="w-full [@media(min-width:456px)]:w-2/3">
              <FormTextField
                className="pp-height"
                name={"verifyCode"}
                placeholder={createMessage(
                  LOGIN_PAGE_CAPTCHA_INPUT_PLACEHOLDER,
                )}
                type="text"
              />
            </div>
            <div className="w-full [@media(min-width:450px)]:w-1/3 flex justify-end mt-2 [@media(min-width:450px)]:mt-0">
              <a
                onClick={async () => fetchCaptcha()}
                className="flex items-center"
              >
                <img
                  alt={"captcha"}
                  src={captchaBlobUrl}
                  style={{
                    width: "100px",
                    height: "45px",
                    cursor: "pointer",
                  }}
                  title={createMessage(LOGIN_PAGE_REFRESH_CAPTCHA_TEXT)}
                />
              </a>
            </div>
          </div>
        </FormGroup>
        <FormActions className="pp-height pp-font">
          {/* <ConfigProvider
            theme={{
              token: {
                colorBgContainer:
                  "linear-gradient(90deg, #13C2C2 0%, #C5AFFF 100%)",
              },
              components: {
                Button: {
                  defaultBg: "linear-gradient(90deg, #13C2C2 0%, #C5AFFF 100%)",
                  defaultColor: disabled ? "inherit" : "#fff",
                  defaultHoverColor: "#fff",
                },
              },
            }}
          >
            <AntdButton
              disabled={disabled}
              size="large"
              type="default"
              htmlType="submit"
            >
              {createMessage(FORGOT_PASSWORD_PAGE_SUBMIT_BUTTON_TEXT)}
            </AntdButton>
          </ConfigProvider> */}
          <GradientButton
            disabled={disabled}
            size="large"
            htmlType="submit"
            onClick={handleSubmit(forgotPasswordSubmitHandler)}
          >
            {createMessage(FORGOT_PASSWORD_PAGE_SUBMIT_BUTTON_TEXT)}
          </GradientButton>
        </FormActions>
      </StyledForm>
      {/* 底部提示 */}
      <FormBottom>
        {createMessage(ALREADY_HAVE_AN_ACCOUNT)}
        <StyledLink
          className="t--sign-up t--signup-link"
          kind="primary"
          target="_self"
          to={AUTH_LOGIN_URL}
        >
          {createMessage(SIGNUP_PAGE_LOGIN_LINK_TEXT)}
        </StyledLink>
      </FormBottom>
    </Container>
  );
};

const selector = formValueSelector(FORGOT_PASSWORD_FORM_NAME);

export default connect((state, props: ForgotPasswordProps) => {
  const queryParams = new URLSearchParams(props.location.search);
  return {
    initialValues: {
      email: queryParams.get("email") || "",
      verifyCode: queryParams.get("verifyCode") || "",
    },
    emailValue: selector(state, "email"),
    verifyCode: selector(state, "verifyCode"),
  };
})(
  reduxForm<
    ForgotPasswordFormValues,
    { emailValue: string; verifyCode: string }
  >({
    validate,
    form: FORGOT_PASSWORD_FORM_NAME,
    touchOnBlur: true,
  })(withRouter(ForgotPassword)),
);
